import { jsx } from "react/jsx-runtime";
import { TamaguiProvider as OGProvider } from "@tamagui/core";
import { PortalProvider } from "@tamagui/portal";
const TamaguiProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx(OGProvider, { ...props, children: /* @__PURE__ */ jsx(PortalProvider, { shouldAddRootHost: true, children }) });
};
export {
  TamaguiProvider
};
//# sourceMappingURL=TamaguiProvider.js.map
